import React from 'react';
import { tUi } from '../utils/uiText';

export default function NationStateConsent({
  accepted,
  onAccept,
  acknowledgedBy,
  onAcknowledgedByChange,
  uiLanguage = 'en',
}) {
  if (accepted) {
    return (
      <div className="mb-4 rounded-lg border border-green-500/30 bg-green-950/20 p-4 text-sm text-green-200">
        {tUi(uiLanguage, 'consentRecorded')}
      </div>
    );
  }

  return (
    <div className="mb-4 rounded-lg border border-yellow-500/40 bg-yellow-950/20 p-4">
      <h3 className="text-lg font-semibold text-yellow-300 mb-2">{tUi(uiLanguage, 'consentTitle')}</h3>
      <p className="text-sm text-yellow-100/90 mb-4">
        {tUi(uiLanguage, 'consentBody')}
      </p>
      <div className="flex flex-col md:flex-row gap-3">
        <input
          value={acknowledgedBy}
          onChange={(e) => onAcknowledgedByChange(e.target.value)}
          placeholder={tUi(uiLanguage, 'consentPlaceholder')}
          autoFocus
          className="flex-1 px-3 py-2 bg-black border border-yellow-500/30 rounded-lg text-white"
        />
        <button
          type="button"
          onClick={onAccept}
          disabled={!acknowledgedBy.trim()}
          className="px-4 py-2 bg-yellow-500 hover:bg-yellow-400 disabled:bg-gray-700 text-black font-semibold rounded-lg"
        >
          {tUi(uiLanguage, 'consentButton')}
        </button>
      </div>
    </div>
  );
}
